import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";

import { messages } from "@app/messages";
import { GlobalState } from "@app/models/state";
import { setTitleOnPage } from "@app/util";
import { canViewGlobalStats as canViewGlobalStatsSelector } from "@sales/selectors";
import { Iframe } from "@oldwata/components/Iframe";
import { Page } from "@ui/Page";

interface StatisticsIndexStateProps {
    canViewGlobalStats: boolean;
}

const StatisticsIndex = ({ canViewGlobalStats }: StatisticsIndexStateProps) => (
    <Page fluid style="blank" className="statistics-index-page">
        {canViewGlobalStats &&
            <Iframe path="/sales/revenueShare" />
        }
    </Page>
);

// Map the users state to the component.
const mapStateToProps = (state: GlobalState) => {
    return {
        canViewGlobalStats: canViewGlobalStatsSelector(state),
    } as StatisticsIndexStateProps;
};

const ConnectedStatisticsIndex = compose<StatisticsIndexStateProps, {}>(
    setTitleOnPage(
        messages.pageStatisticsTitle,
    ),
    connect(mapStateToProps, null),
)(StatisticsIndex);

export {
    StatisticsIndex as StatisticsIndexPresenter,
    ConnectedStatisticsIndex as StatisticsIndex,
};
